<template>
    <div>
        <AppSearchComponent
                :itemPerPage="5"
                :listItems="facebookTopMention"
                :ready="ready"
                :searchable="true"
                searchBy="name"
        >
            <template v-slot:title>
                <h3 class="subheading font-weight-regular section-title--color">{{name}}</h3>
            </template>
            <template v-slot:no-items>Sorry, Facebook Top Mention Temporarily not Available!</template>
            <template v-slot:list-item="props">
                <v-list style="max-height:412px;">
                    <v-list-tile
                            :key="fb_top_mention.id"
                            avatar
                            class="mb-4"
                            v-for="fb_top_mention in props.listView"
                    >
                        <v-list-tile-action>
                            <v-checkbox
                                    :disabled="!monitorActionReady"
                                    :value="fb_top_mention.id"
                                    @change="postFilter"
                                    class="custom-checkbox-size"
                                    color="bindezcolor"
                                    hide-details
                                    v-model="topMention"
                            ></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-avatar size="50">
                            <v-img @error="avatarImageErrorHandler" :src="avatarImage(`//graph.facebook.com/${fb_top_mention.id}/picture?width=50`)"></v-img>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <a
                                        :href="`https://www.facebook.com/${fb_top_mention.id}`"
                                        style="color:#000; text-decoration:none;"
                                        target="_blank"
                                >
                                    <h4
                                            class="zawgyi body-1 font-weight-medium"
                                            style="max-width: 11px;"
                                    >
                                        {{fb_top_mention.name | truncateString }}
                                    </h4>
                                </a>
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                                <v-icon small>group</v-icon>
                                <span @click="displayGrowthRate(fb_top_mention.id, fb_top_mention.name)" class="add-cursor caption description--color">{{fb_top_mention.fan_count | formatNumber }}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-tooltip top>
                            <template slot="activator" slot-scope="{on}">
                                <v-chip
                                        color="bindezcolor"
                                        label
                                        small
                                        text-color="#fff"
                                        v-on="on">
                                    {{ fb_top_mention.count | abbrNumber }}
                                </v-chip>
                            </template>
                            <span>{{fb_top_mention.count | formatNumber}}</span>
                        </v-tooltip>
                    </v-list-tile>
                </v-list>
            </template>
        </AppSearchComponent>
        <v-dialog v-model="fanCountGrowthRateStatus" width="750">
            <v-card color="#f4f4f4" flat>
                <v-card-title class="justify-space-between">
                    <h2 style="color: var(--bindez-green-color);" class="zawgyi">{{sourceName | fromUnicodeToZawgyi}}'s Page Like Growth Rate</h2>
                    <v-icon
                            @click="fanCountGrowthRateStatus = false"
                            medium
                    >
                        far fa-times-circle
                    </v-icon>
                </v-card-title>
                <v-card-text>
                    <v-container container-fluid grid-list-lg px-0 py-1>
                        <v-layout row wrap>
                            <v-flex
                                    :key="index"
                                    v-for="({title, range, count, rate}, index) in fanCountGrowthRate.growthRate"
                                    xs12
                                    sm6
                            >
                                <v-card color="#fff;" flat>
                                    <v-card-text>
                                        <h3 class="title mb-2">{{title}}</h3>
                                        <v-progress-circular
                                                class="mt-2"
                                                color="bindezcolor"
                                                indeterminate
                                                v-if="isGrowthRateLoading"
                                        ></v-progress-circular>
                                        <template v-else>
                                            <p class="subheading description--color">{{range}}</p>
                                            <span>
                                                {{count | formatNumber }}
                                                <template v-if="rate">
                                                    <v-icon :color="rate > 0 ? 'bindezcolor' : 'negative'" small>
                                                         {{ rate > 0 ? "fas fa-caret-up" : "fas fa-caret-down" }}
                                                     </v-icon>
                                                    <span class="description--color"> {{rate}} % from last week</span>
                                                </template>
                                            </span>
                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12>
                                <v-card class="d-flex align-center" flat min-height="300">
                                    <div class="text-xs-center" v-if="isGrowthRateLoading" >
                                        <v-progress-circular color="bindezcolor" indeterminate></v-progress-circular>
                                    </div>
                                    <v-card-text v-else>
                                        <LineChart
                                                :chartData="fanCountGrowthRate.growthRateByTime"
                                                :height="250"
                                                :options="{legend:{display:false}}"
                                                :width="550"
                                        ></LineChart>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
	import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
	import authCurrentUser from "@/mixins/authCurrentUser";
	import AppSearchComponent from "../AppSearchComponent";
	import LineChart from "../LineChart";
	import moment from "moment";
    import _chunk from "lodash/chunk";
    import rabbit from "rabbit-node";
    import knayi from "knayi-myscript";
    import imageFallback from "../../mixins/imageFallback";
	export default {
		name: "FacebookTopMention",
		components: {
			AppSearchComponent,
            LineChart
		},
		mixins: [authCurrentUser, imageFallback],
		model: {
			prop: "selectedFacebookPages",
			event: "change",
		},
		props: {
			facebookTopMention: {
				type: Array,
				required: true,
				default() {
					return []
				}
			},
            ready:{
				type:Boolean,
                required:true,
            },
            selectedFacebookPages:{
				type:Array,
                required:true,
            },
            name:{
				type:String,
            }
		},
        data(){
			return{
				isGrowthRateLoading: false,
				fanCountGrowthRateStatus:false,
                sourceName:"",
			}
        },

		computed: {
			...mapState([
				'monitorActionReady'
			]),

			...mapState("mention", {
				fanCountGrowthRate: state => {
					let {range_count, new_page_likes, total_page_likes} = state.growthRate;
					let data = [], labels = [];
					_chunk(range_count, 2).forEach(([label, count]) => {data.push(count);labels.push(label);});
					let growthRate = [total_page_likes, new_page_likes].map(({count, start, end, rate}) => ({
						range: `${moment(start).format("MMM DD")} - ${moment(end).format("MMM DD")}`,
                        count,
                        rate: rate || 0
                    }));
					growthRate[0].title="Total Page Likes";
					growthRate[1].title="New Page Like";
					let growthRateByTime = {
						datasets: [{
							backgroundColor: "rgba(31, 101, 197, 0.1)",
							borderColor: "#1f65c5",
							fill: true,
							data,
						}],
						labels
					}
					return {growthRate, growthRateByTime}
				}
			}),

			topMention: {
				get() {
					return this.selectedFacebookPages;
				},
				set(page) {
					this.$emit("change", page);
				}
			}
		},

		methods: {
			...mapActions("mention", [
				"fetchFanCountGrowthRate"
			]),

			displayGrowthRate(id, name) {
				this.sourceName = name;
				this.fanCountGrowthRateStatus = true;
				this.isGrowthRateLoading = true;
				this.fetchFanCountGrowthRate({id})
					.then(_ => {
						this.isGrowthRateLoading = false;
					})
			},

			postFilter() {
				this.$emit('filter');
				this.$ua.trackEvent("Filter Post", "check", `${this.authenticatedUser.email || 'User'} filter by facebook top mention`);
			},
		},

        filters:{
			fromUnicodeToZawgyi(str){
				return knayi.fontDetect(str) === 'zawgyi' ? str : rabbit.uni2zg(str);
            }
        }
	};
</script>

<style scoped>
</style>
